module.exports = __webpack_public_path__ + "img/j4.adba7b7a.jpg";